import React, { useEffect, useState } from "react";
import DoughnutChart from "../../../component/Charts/DashChart";
import DashboardAnalytics from "../../../component/dashboard/DashboardAnalytics";
import { apiRequest } from "../../../utils/config/apiRequest";
import { apiUrl } from "../../../utils/endPoints/apiUrl";
import { fDate, fDateUTC } from "../../../utils/helper/timeHelpers";
import DashboardFilter from "../../../component/dashboard/DashboardFilter";
import RecentBookings from "../../../component/dashboard/RecentOrders";
import { useDispatch, useSelector } from "react-redux";
import { fetchShopList } from "../../../store/slices/shopSlice";

const Dashboard = () => {
  const today = new Date();

  const dispatch = useDispatch();
  const { shopListing } = useSelector((state) => state.shops);

  const shops = shopListing?.rows?.map((s) => ({
    id: s._id,
    name: s.name,
  }));

  const [dashboardData, setDashboardData] = useState({});
  const [recentOrders, setRecentOrders] = useState([]);

  const [filters, setFilters] = useState({
    shopId: "",
    year: "",
  });

  const years = [2020, 2021, 2022, 2023, 2025];

  const fetchRecentOrders = async (filtersData = {}) => {
    try {
      const { data, status } = await apiRequest({
        endUrl: apiUrl.orders.root,
        method: "GET",
        query: {
          shopId: filtersData.shopId || "",
          year: filtersData.year || "",
        },
      });

      if (status) {
        setRecentOrders(data.rows || []);
      }
    } catch (error) {
      console.error("Error fetching recent bookings:", error);
    }
  };


  const fetchDashboardData = async (filtersData = {}) => {
    try {
      const { data, status } = await apiRequest({
        endUrl: apiUrl.dashboard.anayltics,
        method: "GET",
         query: {
          shopId: filtersData.shopId || "",
          year: filtersData.year || "",
        },
      });

      if (status) {
        setDashboardData(data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };


  const handleFilterSearch = (data) => {
    setFilters(data);
    fetchDashboardData(data);
    fetchRecentOrders(data);
  };


  useEffect(() => {
    fetchDashboardData();
    fetchRecentOrders();
  }, []);

  useEffect(() => {
    dispatch(fetchShopList());
  }, [dispatch]);

  return (
    <>
      <section className="content mb-5">
        <div className="container-fluid">
          <div className="row titlepad">
            <div className="col-md-12">
              <div className="mt-3 mb-3">
                <div className="dashbed-border-bottom"></div>
              </div>

              <div className="row">
                <div className="col-sm-3">
                  <p>Showing result as on {fDateUTC(today, null, "DD MMM YYYY")}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <DashboardFilter
                shops={shops}
                years={years}
                onSearch={handleFilterSearch}
              />

              <div className="row">
                <div className="col-md-12">
                  <h5 className=" mt-3">Dashboard</h5>
                  <div className="mt-2 mb-2">
                    <div className="dashbed-border-bottom"></div>
                  </div>
                </div>

                {/* Analytics Section */}
                <DashboardAnalytics dashboardData={dashboardData} />

                {/* Recent Bookings */}
                <RecentBookings recentOrders={recentOrders} />

                <section className="col-lg-4 connectedSortable">
                  <div className="card">
                    <div className="card-header border-0 pb-0">
                      <h4 className="card-title float-none">Earning</h4>
                      <p className="f-14">In $</p>
                    </div>
                    <div className="card-body pt-0 px-0 jcc d-flex">
                      <DoughnutChart dashboardData={dashboardData}/>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dashboard;
